const CHANGING_CAREERS = 'changing-careers';
const DIVERSITY_INCLUSION = 'diversity-inclusion';
const FUTURE_OF_WORK = 'future-of-work';
const INTERVIEW_OFFERS = 'interview-offers';
const JOB_SEARCH = 'job-search';
const MAKE_MONEY = 'make-money';
const LANDING_A_PROMOTION = 'landing-a-promotion';
const LEAVING_A_JOB = 'leaving-a-job';
const MANAGEMENT_LEADERSHIP = 'management-leadership';
const NAVIGATING_A_WORKPLACE = 'navigating-the-workplace';
const PROFESSIONAL_DEVELOPMENT = 'professional-development';

export const labelToTextMap = {
    career: 'Career',
    money: 'Money',
    'style-beauty': 'Style & Beauty',
    'diversity-inclusion': 'Diversity & Inclusion',
    health: 'Health',
    'getting-more-done': 'Getting More Done',
    'lifestyle-relationships': 'Lifestyle & Relationships',
    'news-entertainment': 'News & Entertainment',
    parenting: 'Parenting',
    'women-in-tech': 'Women In Tech',
    travel: 'Travel',
    management: 'Management',
    'other-stuff': 'Other Stuff',
    food: 'Food',
    consulting: 'Consulting',
    'the-career-climb': 'The Career Climb',
    'the-balance-work-home': 'The Balance: Work & Home',
    'pregnancy-fertility': 'Pregnancy & Fertility',
    'being-a-boss-lady': 'Being A Boss Lady',
    'maternity-leave': 'Maternity Leave',
};

export const hashTopicMap = {
    '60jpyemW2': { topic: NAVIGATING_A_WORKPLACE },
    '89JngKgYh': { topic: LEAVING_A_JOB },
    '9S7C0oSmi': { topic: INTERVIEW_OFFERS, featured: true },
    DNI2ueZ_D: { topic: PROFESSIONAL_DEVELOPMENT },
    gqIle9w7S: { topic: LANDING_A_PROMOTION },
    gZhRbsLl4: { topic: DIVERSITY_INCLUSION },
    jbsOFDgRO: { topic: MANAGEMENT_LEADERSHIP },
    LB7VEK553: { topic: JOB_SEARCH, featured: true },
    pl0UZObMr: { topic: NAVIGATING_A_WORKPLACE },
    PUlFO86KR: { topic: NAVIGATING_A_WORKPLACE },
    'q-nU3U2MR': { topic: FUTURE_OF_WORK },
    qd4qN6xkC: { topic: LEAVING_A_JOB },
    Qr2syvTRd: { topic: CHANGING_CAREERS },
    v7WyFgodY: { topic: FUTURE_OF_WORK },
    V9Kj6J2zk: { topic: MANAGEMENT_LEADERSHIP },
    ZAjJVER9S: { topic: PROFESSIONAL_DEVELOPMENT },
    Zr5pUn1Lr: { topic: INTERVIEW_OFFERS },
    '9-ways-to-show-your-authentic-self-throughout-the-job-search-process--and-why-it-matters': {
        topic: JOB_SEARCH,
    },
    'small-business-grants-for-women-and-how-to-apply': {
        topic: MAKE_MONEY,
    },
    'joint-bank-account-is-it-a-good-idea': {
        topic: MAKE_MONEY,
    },
    'how-to-pay-yourself-as-a-business-owner': {
        topic: MAKE_MONEY,
    },
    'financial-tips-every-woman-should-know': {
        topic: MAKE_MONEY,
    },
    'real-estate-investing-for-beginners': {
        topic: MAKE_MONEY,
    },
    '50-20-30-budget': {
        topic: MAKE_MONEY,
    },
    'how-to-cope-after-being-rightsized-out-of-a-company': {
        topic: LEAVING_A_JOB,
    },
    '3-ways-managers-can-become-advocates-for-dei-at-work': {
        topic: DIVERSITY_INCLUSION,
        featured: true,
    },
    '4-ways-to-explain-a-career-change-in-an-interview': {
        topic: CHANGING_CAREERS,
    },
    '5-things-highly-effective-managers-do-every-day-for-their-team': {
        topic: MANAGEMENT_LEADERSHIP,
    },
    '5-ways-to-protect-your-mental-health-during-a-stressful-job-search': {
        topic: JOB_SEARCH,
    },
    '6-soft-skills-that-matter-more-than-hard-work': {
        topic: LANDING_A_PROMOTION,
    },
    'employee-are-learning-to-act-their-wage': { topic: FUTURE_OF_WORK },
    'have-you-been-gaslighted-at-work': { topic: NAVIGATING_A_WORKPLACE },
    'how-to-ask-for-a-promotion': { topic: LANDING_A_PROMOTION },
    'im-a-communication-expert--utilize-these-tips-to-negotiate-confidently-at-work': {
        topic: PROFESSIONAL_DEVELOPMENT,
    },
    'leaving-my-overly-demanding-job-was-the-best-thing-ive-ever-done--heres-why': {
        topic: LEAVING_A_JOB,
    },
    'no-your-dei-courses-wont-create-an-equitable-workplace-heres-what-will-actually-help': {
        topic: DIVERSITY_INCLUSION,
    },
    'situational-interview-questions': { topic: INTERVIEW_OFFERS },
    'successful-women-ask-themselves-these-5-questions-to-make-sure-their-work-aligns-with-their-goals': {
        topic: PROFESSIONAL_DEVELOPMENT,
    },
    'what-matters-most-to-todays-job-seekers': { topic: JOB_SEARCH },
    fSLJGk4HL: { topic: CHANGING_CAREERS },
    'im-a-career-strategist---heres-5-subtle-signs-its-time-to-consider-changing-careers': {
        topic: CHANGING_CAREERS,
    },
    '8kusxJ62t': { topic: CHANGING_CAREERS },
    '4-times-you-should-take-a-job-with-a-pay-cut-according-to-a-career-strategist': {
        topic: CHANGING_CAREERS,
    },
    'benefits-lgbt-friendly-companies-need-to-have': {
        topic: DIVERSITY_INCLUSION,
    },
    kzkppDTbB: { topic: DIVERSITY_INCLUSION },
    '5-ways-job-searching-is-harder-for-black-women': {
        topic: DIVERSITY_INCLUSION,
    },
    H8mMnlJZCc: { topic: DIVERSITY_INCLUSION },
    '3-ways-to-promote-a-diverse-and-inclusive-company-culture-even-when-youre-not-a-manager': {
        topic: DIVERSITY_INCLUSION,
    },
    'how-to-network-in-a-virtual-environment': { topic: FUTURE_OF_WORK },
    '67FD2fkCP': { topic: FUTURE_OF_WORK },
    '7z696ulxD': { topic: FUTURE_OF_WORK },
    '6-reasons-people-should-want-to-go-into-the-office--at-least-some-of-the-time': {
        topic: FUTURE_OF_WORK,
    },
    ibnTGtTh8: { topic: FUTURE_OF_WORK },
    'strengths-and-weaknesses': { topic: INTERVIEW_OFFERS },
    BHaU_gO45_: { topic: INTERVIEW_OFFERS },
    'how-to-reschedule-an-interview': { topic: INTERVIEW_OFFERS },
    Y5xIsYbjh: { topic: INTERVIEW_OFFERS },
    '7tkWqtFQW': { topic: INTERVIEW_OFFERS },
    'career-portfolio': { topic: JOB_SEARCH },
    U3xGGcLG7: { topic: JOB_SEARCH },
    '8-ways-to-beat-ageism-on-your-resume--according-to-an-expert': {
        topic: JOB_SEARCH,
    },
    '3-biggest-job-search-challenges-during-todays-uncertain-times': {
        topic: JOB_SEARCH,
    },
    kqGVDaR8F: { topic: JOB_SEARCH },
    'what-to-do-when-youve-been-passed-over-for-a-promotion': {
        topic: LANDING_A_PROMOTION,
    },
    uAqAonZzm: { topic: LANDING_A_PROMOTION },
    'this-is-the-real-reason-women-dont-get-promoted-as-often-as-men': {
        topic: LANDING_A_PROMOTION,
    },
    '3-phrases-you-should-never-use-when-asking-for-a-promotion--and-1-you-should': {
        topic: LANDING_A_PROMOTION,
    },
    r1K4SPBrS: { topic: LANDING_A_PROMOTION },
    qmKmsC4g8: { topic: LEAVING_A_JOB },
    'resignation-letter-samples': { topic: LEAVING_A_JOB },
    'quitting-was-the-best-decision-for-my-career--heres-why': {
        topic: LEAVING_A_JOB,
    },
    wlyBHUGcI: { topic: LEAVING_A_JOB },
    'farewell-email': { topic: LEAVING_A_JOB },
    '8-ways-to-be-an-intuitive-leader-even-when-youre-not-a-manager': {
        topic: MANAGEMENT_LEADERSHIP,
    },
    'nk6-XmIOB': { topic: MANAGEMENT_LEADERSHIP },
    rJCEuZtuE: { topic: MANAGEMENT_LEADERSHIP },
    'going-back-to-work-after-maternity-leave-read-this-guide-first': {
        topic: MANAGEMENT_LEADERSHIP,
    },
    'BpVSDgh-x': { topic: MANAGEMENT_LEADERSHIP },
    'bullying-and-harassment': { topic: NAVIGATING_A_WORKPLACE },
    rOGui9qdS: { topic: NAVIGATING_A_WORKPLACE },
    'emotionally-charged': { topic: NAVIGATING_A_WORKPLACE },
    'mbU5F-hrt': { topic: NAVIGATING_A_WORKPLACE },
    iMDHJolvT: { topic: NAVIGATING_A_WORKPLACE },
    'creative-thinking-how-to-develop-great-ideas-at-work': {
        topic: PROFESSIONAL_DEVELOPMENT,
    },
    LL6nKyNqb: { topic: PROFESSIONAL_DEVELOPMENT },
    'im-a-ceo-here-are-4-ways-successful-women-bounce-back-from-failure': {
        topic: PROFESSIONAL_DEVELOPMENT,
    },
    'starting-a-new-job': { topic: PROFESSIONAL_DEVELOPMENT },
    t18P11UtH: { topic: PROFESSIONAL_DEVELOPMENT },
    'job-search-career-change': { topic: CHANGING_CAREERS },
};

export const adviceHashMap = {
    'community-discussion': [
        '60jpyemW2',
        '67FD2fkCP',
        '7tkWqtFQW',
        '7z696ulxD',
        '89JngKgYh',
        '8kusxJ62t',
        '9S7C0oSmi',
        'BHaU_gO45_',
        'BpVSDgh-x',
        'DNI2ueZ_D',
        'fSLJGk4HL',
        'gqIle9w7S',
        'gZhRbsLl4',
        'H8mMnlJZCc',
        'ibnTGtTh8',
        'iMDHJolvT',
        'jbsOFDgRO',
        'kqGVDaR8F',
        'kzkppDTbB',
        'LB7VEK553',
        'LL6nKyNqb',
        'mbU5F-hrt',
        'nk6-XmIOB',
        'pl0UZObMr',
        'PUlFO86KR',
        'q-nU3U2MR',
        'qd4qN6xkC',
        'qmKmsC4g8',
        'Qr2syvTRd',
        'Qr2syvTRd',
        'r1K4SPBrS',
        'rJCEuZtuE',
        'rOGui9qdS',
        't18P11UtH',
        'U3xGGcLG7',
        'uAqAonZzm',
        'v7WyFgodY',
        'V9Kj6J2zk',
        'wlyBHUGcI',
        'Y5xIsYbjh',
        'ZAjJVER9S',
        'Zr5pUn1Lr',
        'S1Y-EdnHem',
    ],
    'editorial-content': [
        '3-biggest-job-search-challenges-during-todays-uncertain-times',
        '3-phrases-you-should-never-use-when-asking-for-a-promotion--and-1-you-should',
        '3-ways-to-promote-a-diverse-and-inclusive-company-culture-even-when-youre-not-a-manager',
        '4-times-you-should-take-a-job-with-a-pay-cut-according-to-a-career-strategist',
        '5-ways-job-searching-is-harder-for-black-women',
        '6-reasons-people-should-want-to-go-into-the-office--at-least-some-of-the-time',
        '8-ways-to-be-an-intuitive-leader-even-when-youre-not-a-manager',
        '8-ways-to-beat-ageism-on-your-resume--according-to-an-expert',
        '9-ways-to-show-your-authentic-self-throughout-the-job-search-process--and-why-it-matters',
        'benefits-lgbt-friendly-companies-need-to-have',
        'bullying-and-harassment',
        'creative-thinking-how-to-develop-great-ideas-at-work',
        'emotionally-charged',
        'going-back-to-work-after-maternity-leave-read-this-guide-first',
        'how-to-cope-after-being-rightsized-out-of-a-company',
        'how-to-network-in-a-virtual-environment',
        'im-a-career-strategist---heres-5-subtle-signs-its-time-to-consider-changing-careers',
        'im-a-ceo-here-are-4-ways-successful-women-bounce-back-from-failure',
        'job-search-career-change',
        'quitting-was-the-best-decision-for-my-career--heres-why',
        'resignation-letter-samples',
        'starting-a-new-job',
        'strengths-and-weaknesses',
        'this-is-the-real-reason-women-dont-get-promoted-as-often-as-men',
        'what-to-do-when-youve-been-passed-over-for-a-promotion',
        'career-portfolio',
        'farewell-email',
        'how-to-reschedule-an-interview',
        '3-ways-managers-can-become-advocates-for-dei-at-work',
        '4-ways-to-explain-a-career-change-in-an-interview',
        '5-things-highly-effective-managers-do-every-day-for-their-team',
        '5-ways-to-protect-your-mental-health-during-a-stressful-job-search',
        '6-soft-skills-that-matter-more-than-hard-work',
        'employee-are-learning-to-act-their-wage',
        'have-you-been-gaslighted-at-work',
        'how-to-ask-for-a-promotion',
        'im-a-communication-expert--utilize-these-tips-to-negotiate-confidently-at-work',
        'leaving-my-overly-demanding-job-was-the-best-thing-ive-ever-done--heres-why',
        'no-your-dei-courses-wont-create-an-equitable-workplace-heres-what-will-actually-help',
        'situational-interview-questions',
        'successful-women-ask-themselves-these-5-questions-to-make-sure-their-work-aligns-with-their-goals',
        'what-matters-most-to-todays-job-seekers',
        'small-business-grants-for-women-and-how-to-apply',
        'joint-bank-account-is-it-a-good-idea',
        'how-to-pay-yourself-as-a-business-owner',
        'financial-tips-every-woman-should-know',
        'real-estate-investing-for-beginners',
        '50-20-30-budget',
    ],
};
